<template>
  <v-content style="height: 100vh; max-height: calc(100%);">
    <v-container fluid pa-0 style="height: 100vh; max-height: calc(100%);">
      <v-row>
        <v-col
          style="height: 100vh; max-height: calc(100%); padding: 0; position: relative; align: center"
        >
          <v-container
            pl-5
            pr-5
            fluid
            style="height: 100vh; max-height: calc(100%);"
          >
            <div>
              <v-btn small @click="sendMessage('hello world')">Increment</v-btn>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script setup lang="ts">
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {},

  mounted() {},
  beforeDestroy() {},
  methods: {
    ...mapActions({}),
    sendMessage() {}
  }
};
</script>
